import React, { useEffect, useRef, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { connect, useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { API_URL } from "../config/app-config";
import dummyimage from "../img/default_avatar.jpg";
import { getPostLikeUsers } from "../redux/actions/PostCardActions";
import InfiniteScroll from "react-infinite-scroll-component";
import FriendsFinder from "../api/FriendsFinder";
import { toast } from "react-toastify";
import { giveUserAction } from "../utils";
import { needPhotVerification } from "../redux/actions/commonApiActions";
import {
  FaThumbsUp,
  FaHeart,
  FaLaugh,
  FaSurprise,
  FaSadTear,
  FaAngry
} from "react-icons/fa";

const LikePopUp = (props) => {
  const { t, modelClose, availableType } = props;
  const [activeMenu, setActiveMenu] = useState(0);
  const [modifyList, setModifyLikeList] = useState([]);
  const [pagNo, setPageNo] = useState(0);
  const dispatch = useDispatch();
  const loginDetails = useSelector(
    (state) => state.loginDetailsApi.loginDetails
  );

  const { likeSeeMore, likeUsersList, likesCount } = useSelector(
    (state) => state.postList
  );
  
  // FIX: Initialize likeTypes with safe defaults
  const [likeTypes, setLikeTypes] = useState({
    like: false,
    love: false,
    haha: false,
    wow: false,
    support: false,
    agree: false,
    likeCount: 0,
    loveCount: 0,
    hahaCount: 0,
    wowCount: 0,
    supportCount: 0,
    agreeCount: 0,
  });
  
  const [modelOpen, setModelOpen] = useState(true);
  const { postId, postType } = props;
  const divRef = useRef();

  // Reaction types mapping
  const reactionTypes = {
    1: { icon: FaThumbsUp, label: "Like", color: "#4267B2" },
    2: { icon: FaHeart, label: "Love", color: "#ff6b6b" },
    3: { icon: FaLaugh, label: "Haha", color: "#feca57" },
    4: { icon: FaSurprise, label: "Wow", color: "#ff9ff3" },
    5: { icon: FaSadTear, label: "Sad", color: "#576574" },
    6: { icon: FaAngry, label: "Angry", color: "#ee5253" }
  };  

  useEffect(() => {
    let data = {
      postId: postId,
      typeData: postType,
      page: 0,
    };
    dispatch(getPostLikeUsers(data, false, "all"));
    return () => {
      setModelOpen(false);
    };
  }, []);

  useEffect(() => {
    setModifyLikeList(likeUsersList);
    
    // FIX: Add null/undefined check before accessing availableType
    if (availableType && typeof availableType === 'object') {
      const newLikeTypes = {
        like: availableType.hasOwnProperty("1"),
        love: availableType.hasOwnProperty("2"),
        haha: availableType.hasOwnProperty("3"),
        wow: availableType.hasOwnProperty("4"),
        support: availableType.hasOwnProperty("5"),
        agree: availableType.hasOwnProperty("6"),
        likeCount: availableType["1"] || 0,
        loveCount: availableType["2"] || 0,
        hahaCount: availableType["3"] || 0,
        wowCount: availableType["4"] || 0,
        supportCount: availableType["5"] || 0,
        agreeCount: availableType["6"] || 0,
      };
      setLikeTypes(newLikeTypes);
    }
  }, [likeUsersList, availableType]);

  const showFriendsProfile = (userId) => {
    props.history.push(`/${props.workspaceType}/friendDescription/${userId}`, {
      from: window.location.pathname,
    });
  };

  const changeFilterType = (activeId) => {
    setActiveMenu(activeId);
    setPageNo(0);
    const data = activeId !== 0
      ? {
          postId: postId,
          typeData: postType,
          reactionType: activeId,
          page: 0,
        }
      : {
          postId: postId,
          typeData: postType,
          page: 0,
        };
    
    dispatch(getPostLikeUsers(data, false, "no"));
  };

  const needMoreData = () => {
    const data = activeMenu !== 0
      ? {
          postId: postId,
          typeData: postType,
          reactionType: activeMenu,
          page: pagNo + 1,
        }
      : {
          postId: postId,
          typeData: postType,
          page: pagNo + 1,
        };
    
    dispatch(getPostLikeUsers(data, true, "no"));
    setPageNo(pagNo + 1);
  };

  const addFriend = (id, type) => {
    if (giveUserAction(loginDetails?.profile_complete)) {
      setModelOpen(false);
      dispatch(needPhotVerification(true));
    } else if (type === "notFriends") {
      const getRequestedFriends = {
        friendsId: id,
        requestStatus: "requested",
      };
      
      FriendsFinder.friendRequest(getRequestedFriends)
        .then((response) => {
          const changeStatus = modifyList.map((item) => {
            if (item.userId === id) {
              return { ...item, type: "giveRequest" };
            }
            return item;
          });
          setModifyLikeList(changeStatus);
          toast.success(`${props.t("Request sent successfully")}`);
        })
        .catch((error) => {
          console.error("Friend request error:", error);
        });
    }
  };
  
  const getReactionIcon = (type) => {
    const Icon = reactionTypes[type]?.icon || FaThumbsUp;
    return (
      <Icon 
        style={{ 
          fontSize: "1.5rem",
          color: reactionTypes[type]?.color || "#4267B2" 
        }} 
      />
    );
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      classes={{ paper: "top-dialog-paper" }}
      open={modelOpen}
      onClose={() => modelClose()}
    >
      <DialogTitle>
        {t("People who reacted")}

        <AiOutlineCloseCircle
          onClick={modelClose}
          style={{
            cursor: "pointer",
            float: "right",
            marginBottom: "8px",
            width: "20px",
            height: "20px",
            color: "#000000",
          }}
        />
        <hr className="mt-0" />
        <ul
          style={{ 
            marginBottom: "17px",
            display: "flex",
            justifyContent: "center",
            padding: "10px 0",
            gap: "15px",
            flexWrap: "wrap"
          }}
          className="pop-up-images"
        >
          <li
            className={`reaction-filter ${activeMenu === 0 ? "active" : ""}`}
            onClick={() => changeFilterType(0)}
          >
            <span>{t("All")}</span>
            <span className="badge badge-info ml-1">{likesCount}</span>
          </li>
          
          {/* FIX: Add null checks before accessing likeType properties */}
          {likeTypes.like && (
            <li
              className={`reaction-filter ${activeMenu === 1 ? "active" : ""}`}
              onClick={() => changeFilterType(1)}
            >
              <div className="reaction-icon">
                {getReactionIcon(1)}
              </div>
              <span className="badge badge-info ml-1">{likeTypes.likeCount}</span>
            </li>
          )}
          
          {likeTypes.love && (
            <li
              className={`reaction-filter ${activeMenu === 2 ? "active" : ""}`}
              onClick={() => changeFilterType(2)}
            >
              <div className="reaction-icon">
                {getReactionIcon(2)}
              </div>
              <span className="badge badge-info ml-1">{likeTypes.loveCount}</span>
            </li>
          )}
          
          {likeTypes.haha && (
            <li
              className={`reaction-filter ${activeMenu === 3 ? "active" : ""}`}
              onClick={() => changeFilterType(3)}
            >
              <div className="reaction-icon">
                {getReactionIcon(3)}
              </div>
              <span className="badge badge-info ml-1">{likeTypes.hahaCount}</span>
            </li>
          )}
          
          {likeTypes.wow && (
            <li
              className={`reaction-filter ${activeMenu === 4 ? "active" : ""}`}
              onClick={() => changeFilterType(4)}
            >
              <div className="reaction-icon">
                {getReactionIcon(4)}
              </div>
              <span className="badge badge-info ml-1">{likeTypes.wowCount}</span>
            </li>
          )}
          
          {likeTypes.support && (
            <li
              className={`reaction-filter ${activeMenu === 5 ? "active" : ""}`}
              onClick={() => changeFilterType(5)}
            >
              <div className="reaction-icon">
                {getReactionIcon(5)}
              </div>
              <span className="badge badge-info ml-1">{likeTypes.supportCount}</span>
            </li>
          )}
          
          {likeTypes.agree && (
            <li
              className={`reaction-filter ${activeMenu === 6 ? "active" : ""}`}
              onClick={() => changeFilterType(6)}
            >
              <div className="reaction-icon">
                {getReactionIcon(6)}
              </div>
              <span className="badge badge-info ml-1">{likeTypes.agreeCount}</span>
            </li>
          )}
        </ul>
      </DialogTitle>
      
      <DialogContent dividers="paper" style={{ overflow: "hidden" }}>
        <InfiniteScroll
          dataLength={modifyList?.length || 0}
          next={needMoreData}
          hasMore={likeSeeMore}
          scrollableTarget="scrollable_div"
          loader={<div className="text-center my-2">Loading...</div>}
        >
          <div
            id="scrollable_div"
            style={{
              minHeight: "auto",
              maxHeight: "29.5rem",
              overflow: "auto",
              overflowX: "hidden",
              padding: "10px"
            }}
            ref={divRef}
          >
            {modifyList.length > 0 ? (
              modifyList.map((item) => (
                <div key={item.userId} className="d-flex align-items-center mt-2 mb-3">
                  <div className="post-avatar post-avatar-story me-2">
                    <img
                      style={{ cursor: "pointer", objectFit: "cover" }}
                      onClick={() => showFriendsProfile(item.userId)}
                      className="post-avatar-img rounded-circle"
                      src={
                        item.photoPath ? 
                        `${API_URL}api/getUserPhoto/${item.userId}/${item.userName}` :
                        dummyimage
                      }
                      alt="user"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = dummyimage;
                      }}
                    />
                  </div>

                  <div className="d-flex flex-column flex-grow-1">
                    <h6
                      className="post-mb-0 text-capitalize"
                      style={{ cursor: "pointer" }}
                      onClick={() => showFriendsProfile(item.userId)}
                    >
                      {item.userName}
                    </h6>
                    <small className="text-muted">
                      {item.likeReactionType && getReactionIcon(item.likeReactionType)}
                      {item.likeReactionType ? 
                        (reactionTypes[item.likeReactionType]?.label || "Reacted") : 
                        "Reacted"}
                    </small>
                  </div>
                  
                  {/* {(item.type === "notFriends" || item.type === "giveRequest") && (
                    <button
                      className={`btn btn-sm ${item.type === "notFriends" ? "btn-primary" : "btn-secondary"}`}
                      onClick={() => addFriend(item.userId, item.type)}
                    >
                      {item.type === "notFriends" ? "+ Connect" : "Requested"}
                    </button>
                  )} */}
                </div>
              ))
            ) : (
              <div className="text-center py-4">
                <p>{t("No reactions yet")}</p>
              </div>
            )}
          </div>
        </InfiniteScroll>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = function (state) {
  return {
    loginDetails: state.loginDetailsApi.loginDetails,
    loginUserType: state.loginDetailsApi.loginDetails?.uType,
    workspaceType: state.loginDetailsApi.loginDetails.userWorkSpace?.slug,
  };
};

export default connect(
  mapStateToProps,
  null
)(withTranslation()(withRouter(LikePopUp)));